import axiosClient from "../common/axios/axiosConfig";

interface IParams {
	note: number;
	description: string;
	anonimo: boolean;
}

export const createReview = ({ note, description, anonimo = false }: IParams, scheduleId: string) => {
	return axiosClient.post(`/review/${scheduleId}`, {
		note,
		description,
		anonimo,
	});
};
